export default __webpack_public_path__ + "17d5a42b2a5ceec89f74da9bbc3308bd.svg";